import { LatLngBoundsLiteral } from './models/coordinate-search.model';
import { buildViewportAroundPoint } from './coordinate-viewport.util';

export interface ParsedCoordinateLocation {
  lat: number;
  lng: number;
  name?: string;
  viewport?: LatLngBoundsLiteral;
  origin?: string;
}

export function parseCoordinateLocationJson(
  value: string
): ParsedCoordinateLocation | null {
  if (!value) {
    return null;
  }
  try {
    const parsed = JSON.parse(value) as ParsedCoordinateLocation;
    const lat = Number(parsed?.lat);
    const lng = Number(parsed?.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return null;
    }
    return { ...parsed, lat, lng };
  } catch {
    return null;
  }
}

export function isCoordinateOrigin(
  location: ParsedCoordinateLocation | null
): location is ParsedCoordinateLocation {
  return location?.origin === 'coordinate';
}

export function buildCoordinateLocationPayload(
  lat: number,
  lng: number,
  displayLabel: string,
  viewportRadiusMeters = 500
): string {
  const viewport = buildViewportAroundPoint(lat, lng, viewportRadiusMeters);
  return JSON.stringify({
    lat,
    lng,
    name: displayLabel,
    viewport,
    origin: 'coordinate',
  });
}
